export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/BackArrow.526ca914.svg","height":18,"width":11,"blurWidth":0,"blurHeight":0};